$(document).ready(function(){
  var box__id__1 = 1528213012595;
  var box__id__2 = 1794939584627;

  if (window.theme.cart.indexOf(box__id__1) > -1 || window.theme.cart.indexOf(box__id__2) > -1 ) {
    $('#swiper__container__cart__lateral--container').hide();
  } else {
    /*var mySwiperReco = new Swiper ('#swiper-container-cart-lateral', {
      direction: 'horizontal',
      loop: true,
      spaceBetween: 30,
      slidesPerView: 1,
      autoplay: false,
      speed: 600,
      navigation: {
        nextEl: '.swiper-next-top-slider',
        prevEl: '.swiper-prev-top-slider',
      },   
      pagination: {
        el: '.swiper-pagination-reco-lateral',
        type: 'bullets',
        clickable: true
      },
    });*/
    $('#swiper__container__cart__lateral--container').show();
    var prevArrow = `<svg class="slick-arrow--left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="25.46 48.79 1.41 24.75 25.46 0.71"/></g></g></svg>`
    var nextArrow = `<svg class="slick-arrow--right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="0.71 0.71 24.75 24.75 0.71 48.79"/></g></g></svg>`
    $('#swiper-container-cart-lateral').slick({
      dots: true,
      customPaging: function(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  //slider produit sur mobile
  $('.slider-mobile-product').slick({
    dots: true,
    customPaging: function(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Clic add to cart button
  /*$('.product__item__link--container').on('click', function(e) {
    e.preventDefault();
    var productUrl = $(this).attr('href');
    if ($(e.target).attr('class').indexOf('add__to__cart--grid-item') > -1 || $(e.target).parent().attr('class').indexOf('add__to__cart--grid-item') > -1 ) {
    } else {
      window.location = productUrl;
    }
  })*/

  $('.close').on('click', function(){ 
    var forClose = $(this).attr('data-ation');
    if (forClose == "close-modal") {
      $('.Modal').hide();
      $('.PageOverlay').removeClass('is-visible');
      document.dispatchEvent(new CustomEvent('modalClosed'));
    }
  })


  // Cart rendering
  document.addEventListener('renderCart', function (elem) {
    /*if (mySwiperReco) {
      mySwiperReco.destroy();
    }*/
    $('#swiper__container__cart__lateral--container').hide();
    $('.product__reco--image').removeClass('display__none');
    $.ajax({
      type: "GET",
      url: '/cart.js',
      dataType: "json",
      success: function(response) {
        var cart = response;
        var newThemeCart = "";

        for (var i = 0; i < cart.items.length; i++) {
          newThemeCart = newThemeCart + cart.items[i].product_id + ','
        }

        window.theme.cart = newThemeCart;

        // Si une box est dans le panier, pas de slider reco
        if (window.theme.cart.indexOf(box__id__1) > -1 || window.theme.cart.indexOf(box__id__2) > -1 ) {
          $('#swiper__container__cart__lateral--container').hide();
        } else {



          setTimeout(function(){

            $('#swiper__container__cart__lateral--container').show();
            var prevArrow = `<svg class="slick-arrow--left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="25.46 48.79 1.41 24.75 25.46 0.71"/></g></g></svg>`
            var nextArrow = `<svg class="slick-arrow--right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="0.71 0.71 24.75 24.75 0.71 48.79"/></g></g></svg>`
            $('#swiper-container-cart-lateral').slick({
              dots: true,
              customPaging: function(slider, i) {
                return '<button class="tab"></button>';
              },
              infinite: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow,
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }, 1000);

          /*mySwiperReco = new Swiper ('#swiper-container-cart-lateral', {
            direction: 'horizontal',
            loop: true,
            navigation: {
              nextEl: '#swiper-next-top-box',
              prevEl: '#swiper-prev-top-box',
            },
            spaceBetween: 30,
            slidesPerView: 1,
            autoplay: false,
            speed: 600,
            pagination: {
              el: '.swiper-pagination-reco-lateral',
              type: 'bullets',
              clickable: true
            },
          });*/
        }
      },
      error: function(error) {
        console.log('erreur');
      }
    });
  }, false);

  var windowHeight = window.innerHeight / 2 + 50;
  var youtubeLoaded = false;
  var previousScroll = 0;

  $(document).on('scroll', function() {
    if ( $(document).scrollTop() > 85 ) {
      $('#concept').hide();
      // $('#parrainage-box').hide();
      // $('#Header__Wrapper_Nav').css('padding-top', '3px');
      if (window.matchMedia("(max-width: 1024px)").matches) {
        $('#Header__Wrapper_Nav').css('max-height', '50px');
      }

    } else if ($(document).scrollTop() < 30){
      $('#concept').show();
      // $('#parrainage-box').show();
      // $('#Header__Wrapper_Nav').css('padding-top', '10px');
      if (window.matchMedia("(max-width: 1024px)").matches) {
        $('#Header__Wrapper_Nav').css('max-height', '500px');
      }
    }
    
    if (window.location.pathname.indexOf('blogs') > -1 && window.dataLayer) {
      var scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());
      var scrollPos = 0;
      if (scrollPercent >= 100) {
        scrollPos = 100;
      } else if (scrollPercent >= 75) {
        scrollPos = 75;
      } else if (scrollPercent >= 50) {
        scrollPos = 50;
      } else if (scrollPercent >= 25) {
        scrollPos = 25;
      }
      
      if (scrollPos >= 25 && scrollPos != previousScroll) {
        previousScroll = scrollPos;
        window.dataLayer.push({
          "event" : "genericEvent",
          "eventCategory" : "blogArticle",
          "eventAction" : "Scroll",
          "eventLabel" : `>=${ scrollPos }`
        });
        
      }
    }

    if ($(document).scrollTop() > windowHeight && youtubeLoaded == false) {
      $('#video__home--nuoo').attr('src', $('#video__home--nuoo').attr('defer-src'))
      youtubeLoaded = true;
    }


  });

  $('li.is-selected').on('click', function(){
    $(this).parent().hide();
  });

  // Open Link in different tab
  // jQuery('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');

  // Gallery, display thumbs instead of master image
  $('.thumbnail').on('click', function(event) {
    $('#largeImage').fadeOut('slow', function() {
      $('#largeImage').attr('src', event.target.src)
      $('#largeImage').fadeIn('slow');
    });
  });

  // Tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
      });
  });


  // Open Link in different tab
  // jQuery('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');

  // Gallery, display thumbs instead of master image
  $('.thumbnail').on('click', function(event) {
    $('#largeImage').fadeOut('slow', function() {
      $('#largeImage').attr('src', event.target.src)
      $('#largeImage').fadeIn('slow');
    });
  });

  // Tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
      });
  });

  // Collapsible buttons for SideBar
  $(".Collapsible__Button").click(function () {

    $button = $(this);
    //getting the next element
    $arrowDown = $button.find('.arrowToggleDown')
    //getting the image arrow down
    $content = $button.next();
    //set auto height to show full content
    $content.css('height', 'auto');
    //open up the content needed
    $content.slideToggle(50, function () {
        //execute this after slideToggle is done
        $($arrowDown).toggleClass( 'rotate', 10000 );
    });

  });

  // Click on see cart in drawer
  $('#seeCart').on('click', function(e){
    e.preventDefault();
    window.location.href = '/cart';
  });

  //$('.Collapsible--autoExpand--first .Collapsible__Button').click();

  $('#Container_logo').mouseenter(function(event){
    $('.MegaMenu[aria-hidden="false"]').attr('aria-hidden', 'true');
    $('nav.Header__MainNav').removeClass('is-expanded');
    $('ul.HorizontalList').removeClass('is-expanded');
    $('li.HorizontalList__Item').removeClass('is-expanded');
  });

  // Gere le click sur les pastilles de couleur dans les pages collection
  $('.hoverLink').click(function(event) {
    event.preventDefault();
    var $this = $(this);
    if ($(event.target).hasClass('image-picker-collection-link') || $(event.target).hasClass('image-picker-collection')) {
      window.location.href = $(event.target).attr('href');
    } else {
      window.location.href = $this.attr('href');
    }
  });

  var current_img = $('#largeImage').attr('src');

  // Gere le survol des pastilles de collection dans les pages produit
  $('.image-picker:not(.selected)').hover(function(){
    future_img = $(this).attr('img-src');
    $('#largeImage').attr('src', future_img);

  });

  $('.color-container-product').mouseleave(function(){
    $('#largeImage').attr('src', current_img);
  });

  var setCookie = function(name,value) {
    var expires = "";

    var date = new Date();
    date.setTime(date.getTime() + (10*60*1000));
    expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  };
  var getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  };
  // Fil d ariane
  if (window.location.href.indexOf('collections') > -1 && window.location.href.indexOf('products') == -1) {
    setCookie('collection-name', $('h1').text());
  }

  if (window.location.href.indexOf('products') > -1 && document.referrer.indexOf('collections') > -1) {
    $('#breadcrumb-collection-link').text(getCookie('collection-name'));
    $('#breadcrumb-collection-link').attr('href', document.referrer);
    $('.hide-breadcrumb').show();
  }


  // $('.Header__Icon').click()

  document.addEventListener('filter:changed', function (elem) {
    setTimeout(function(){
      var imgDefer = document.getElementsByTagName('img');
      for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute('defer-src')) {
          imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
        }
        if (imgDefer[i].getAttribute('defer-srcset')) {
          imgDefer[i].setAttribute('srcset', imgDefer[i].getAttribute('defer-srcset'));
        }
      }
    }, 1000);
  }, false);

  document.addEventListener('drawer-cart:opened', function (elem) {
    $('.product__reco--image').removeClass('display__none');
  }, false);





  $('.Header__MainNav').on('mouseenter', function() {
    $('.megamenu__image').removeClass('display__none');
  })
});


// Pinterest
/*document.addEventListener('product:added', function (elem) {
  var prevArrow = `<svg class="slick-arrow--left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="25.46 48.79 1.41 24.75 25.46 0.71"/></g></g></svg>`
  var nextArrow = `<svg class="slick-arrow--right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 49.5"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><polyline style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;" points="0.71 0.71 24.75 24.75 0.71 48.79"/></g></g></svg>`
  $('#swiper-container-cart-lateral').slick({
    dots: true,
    customPaging: function(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}, false);*/

$('body').on('click', '.close--container-crossell, #page_overlay-produit-cross-sell, #continue--shopping', function(){
  $('#modale--produit-cross-sell, #page_overlay-produit-cross-sell').removeClass('opened');
})

// Recherche par tags
$( ".search_tag--item" ).click(function() {

    let search_tag = $(this).text();
    $('#df-searchbox__dffullscreen, #df-mobile__searchbox__dffullscreen').val(search_tag);

    let input = document.getElementById("df-searchbox__dffullscreen");
    if (input) {
        input.dispatchEvent(new CustomEvent("df:input:valueChanged"));
    }

    let inputMobile = document.getElementById("df-mobile__searchbox__dffullscreen");
    if (inputMobile) {
        setTimeout(function(){
            console.log(inputMobile)
            inputMobile.dispatchEvent(new CustomEvent("df:input:valueChanged"));
        }, 250);
    }
});

//axeptio

if (window.location.href.indexOf("/carte-cadeau-box-beaute-bio-nuoo") > -1){
  /*$(document).on('product:added', function(e) {
    // Vous pouvez maintenant accéder à `e.detail` pour obtenir les détails envoyés avec l'événement
    console.log('Produit ajouté:', e.detail.variant, 'Quantité:', e.detail.quantity);

    // Effectuez la redirection
    window.location.href = '/cart';
  });*/
}